import { Component, Input, OnInit } from '@angular/core';
import { ConsultationDto } from '../../Resovler/ConsultationDto';
import { environment } from 'src/environments/environment';
import { PageRequest, PaginationPage } from 'src/app/common/modules/data-table.module/interfaces';
import { ConsultationService } from 'src/app/services/consultation.service';
import { AuthService } from 'src/app/services/auth.service/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Doctor } from 'src/app/entities/user.entity/doctor.entity';

@Component({
  selector: 'app-assistance-consultation-card',
  templateUrl: './assistance-consultation-card.component.html',
  styleUrls: ['./assistance-consultation-card.component.css']
})
export class AssistanceConsultationCardComponent implements OnInit {

 
   @Input() currentPage: number = 0;
   @Input() perPage: number = 10;
   doctorConsultations: Array<ConsultationDto> = new Array();
   @Input() pageRequest!: (pageRequest: PageRequest) => Promise<PaginationPage<ConsultationDto>>;
   constructor(
     private consultationsService: ConsultationService,
     private authService: AuthService,
     private toasterService: ToastrService
   ) { }
 
   get doctor(): Doctor {
     return this.authService.getCurrentUser() as Doctor;
   }
   ngOnInit(): void {
     this.currentPage = 0;
   }
  avatarSrc(consultation: ConsultationDto): string {
     return consultation.patientImage ? `http${environment.API_SSL ? 's' : ''}://${environment.API_HOST_NAME}${environment.PORT ? ':' + environment.PORT : ''}/${environment.STORAGE_ENDPOINT}/${consultation.patientImage}` : 'assets/img/user-avatar.png';
   }
   onDeleteConsultation(index: number) {
     window.confirm('Êtes-vous sûr(e) de vouloir supprimer cette   consultation ?');
     this.consultationsService.delete(this.doctorConsultations[index].id).subscribe((res) => {
       this.toasterService.success('Consultation has deleted');
       this.doctorConsultations.splice(index, 1);
     }, error => {
       this.toasterService.error('Enable to delete prescription')
     });
   }
 
 }
